import { render, staticRenderFns } from "./CrmClientesList.vue?vue&type=template&id=cb0b8ec8&scoped=true&"
import script from "./CrmClientesList.vue?vue&type=script&lang=js&"
export * from "./CrmClientesList.vue?vue&type=script&lang=js&"
import style0 from "./CrmClientesList.vue?vue&type=style&index=0&id=cb0b8ec8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb0b8ec8",
  null
  
)

export default component.exports